import { sortingToteIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const AccountSortingToteSchema = z.object({
  id: sortingToteIdFormat.schema,
  name: z.string(),
});

export const listSortingTotes = {
  name: "listSortingTotes" as const,
  input: z.object({}),
  output: z.object({ sortingTotes: z.array(AccountSortingToteSchema) }),
};
